export const checkLinkSelect = (linkToCheck, location, searchQuery) => linkToCheck.split("/")[1].replace(searchQuery, "") === location.pathname.split("/")[1];